// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__36Mez","main":"Wrapper_main__2-2DM"};